"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSignOffProposal = void 0;
var web3_js_1 = require("@solana/web3.js");
var serialisation_1 = require("./serialisation");
var borsh_1 = require("borsh");
var instructions_1 = require("./instructions");
var constants_1 = require("../registry/constants");
var withSignOffProposal = function (instructions, programId, programVersion, realm, governance, proposal, signatory, signatoryRecord, proposalOwnerRecord) {
    var args = new instructions_1.SignOffProposalArgs();
    var data = Buffer.from((0, borsh_1.serialize)((0, serialisation_1.getGovernanceInstructionSchema)(programVersion), args));
    var keys = [];
    if (programVersion > constants_1.PROGRAM_VERSION_V1) {
        keys.push({
            pubkey: realm,
            isWritable: true,
            isSigner: false,
        }, {
            pubkey: governance,
            isWritable: true,
            isSigner: false,
        });
    }
    keys.push({
        pubkey: proposal,
        isWritable: true,
        isSigner: false,
    });
    if (programVersion === constants_1.PROGRAM_VERSION_V1) {
        keys.push({
            pubkey: signatoryRecord,
            isWritable: true,
            isSigner: false,
        }, {
            pubkey: signatory,
            isWritable: false,
            isSigner: true,
        }, {
            pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY,
            isSigner: false,
            isWritable: false,
        });
    }
    else {
        keys.push({
            pubkey: signatory,
            isWritable: false,
            isSigner: true,
        });
        if (proposalOwnerRecord) {
            keys.push({
                pubkey: proposalOwnerRecord,
                isWritable: false,
                isSigner: false,
            });
        }
        else {
            keys.push({
                pubkey: signatoryRecord,
                isWritable: true,
                isSigner: false,
            });
        }
    }
    instructions.push(new web3_js_1.TransactionInstruction({
        keys: keys,
        programId: programId,
        data: data,
    }));
};
exports.withSignOffProposal = withSignOffProposal;
//# sourceMappingURL=withSignOffProposal.js.map